






















































































































import { PointRate } from "@/graphql/client";
import { Component, Ref, Emit, Mixins } from "vue-property-decorator";
import pointRateService from "@/service/pointRateService";
import ProgressLinear from "@/components/molecules/ProgressLinear.vue";
import MixinValidator from "@/components/mixins/point_rate/MixinPointRateEditDialogValidator.vue";
import MixinFormatter from "@/components/mixins/MixinFormatter.vue";
import moment from "moment";

@Component({
  components: {
    ProgressLinear,
  },
})
export default class DiscountPointEditDialog extends Mixins(
  MixinFormatter,
  MixinValidator
) {
  @Ref() readonly itemForm!: HTMLFormElement;
  //---------------------------
  // data
  //---------------------------
  isOpen = false;
  isProgressing = false;
  item: PointRate = pointRateService.defaultPointRate;
  valid = false;
  //---------------------------
  // mounted
  //---------------------------
  //---------------------------
  // computed
  //---------------------------
  /**
   * 「YYY-MM-DD HH:mm:ss」形式の登録日時を取得
   */
  get formattedCreatedAt(): string {
    return this.item.createdAt
      ? moment(this.item.createdAt).format("YYYY-MM-DD HH:mm:ss")
      : "";
  }
  /**
   * 「YYY-MM-DD HH:mm:ss」形式の更新日時を取得
   */
  get formattedUpdatedAt(): string {
    return this.item.updatedAt
      ? moment(this.item.updatedAt).format("YYYY-MM-DD HH:mm:ss")
      : "";
  }

  //---------------------------
  // methods
  //---------------------------
  async fetchData(item: PointRate): Promise<void> {
    this.item = pointRateService.defaultPointRate;
    if (item.guid) {
      const result = await pointRateService.getPointRate(item.guid);
      if (result) {
        this.item = result;
      }
    }
  }
  /**
   * ダイアログを表示します.
   */
  public async open(item: PointRate): Promise<void> {
    await this.fetchData(item);

    this.isProgressing = false;
    this.isOpen = true;
  }

  /**
   * ダイアログを閉じます.
   */
  public close(): void {
    this.$v.$reset();
    this.isProgressing = false;
    this.isOpen = false;
  }

  /**
   * 入力内容を保存します.
   */
  private save(): void {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.isProgressing = true;
      if (this.item.guid) {
        //update
        pointRateService
          .updatePointRate(this.item)
          .then((result) => {
            this.isProgressing = false;
            this.notifyUpdateSuccess(result as PointRate);
          })
          .catch((err) => {
            console.error(err);
            this.notifyError("ポイント付与率を更新できませんでした.");
          });
      } else {
        //create
        pointRateService
          .createPointRate(this.item)
          .then((result) => {
            this.isProgressing = false;
            this.notifyCreateSuccess(result as PointRate);
          })
          .catch((err) => {
            console.error(err);
            this.notifyError("ポイント付与率を登録できませんでした.");
          });
      }
    }
  }

  /**
   * 登録成功
   */
  @Emit("onCreateSuccess")
  public notifyCreateSuccess(created: PointRate): PointRate {
    return created;
  }
  /**
   * 更新成功
   */
  @Emit("onUpdateSuccess")
  public notifyUpdateSuccess(updated: PointRate): PointRate {
    return updated;
  }
  /**
   * 失敗
   */
  @Emit("onError")
  public notifyError(message: string): string {
    return message;
  }
}
